import { Node, NodeProps } from '@xyflow/react';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { EmailIcon, GroupsIcon } from '@/lib/v2/icons/solid';
import { CommonFlowCard } from '@/lib/v3/components';

import { TRANSLATIONS } from '@/src/modules/AutomationModuleNew/constants/flows';
import { useHandleSidePanel } from '@/src/modules/AutomationModuleNew/hooks/Flows/useHandleSidePanel';

import {
  GroupManageContactCard,
  SendEmailCard,
} from '@/modules/AutomationModuleNew/screens/JourneysScreen/components/ActionNodes';
import { ActionNodeData } from '@/modules/AutomationModuleNew/types/flowsTypes';

export interface ActionNodeProps extends NodeProps<Node<ActionNodeData>> {
  onDelete?: (nodeId: string) => void;
}

const ActionNode: FC<ActionNodeProps> = (props) => {
  const { t } = useTranslation();
  const { data, onDelete, id } = props;
  const { handleOpenSidePanel } = useHandleSidePanel();

  const RenderSubTypeComponent = () => {
    if (data.type === 'groupsManageContact') {
      return (
        <GroupManageContactCard
          borderColor="action"
          data={data}
          editAction={{
            label: t('ActionNode.edit'),
            onClick: handleOpenSidePanel,
          }}
          icon={<GroupsIcon />}
          id={id}
          title={t(TRANSLATIONS.nodeTypes.groupsManageContact)}
          onDelete={onDelete}
        />
      );
    }
    if (data.type === 'sendEmail') {
      return (
        <SendEmailCard
          borderColor={'action'}
          data={data}
          editAction={{
            label: t('ActionNode.edit'),
          }}
          icon={<EmailIcon />}
          id={id}
          title={t(TRANSLATIONS.nodeTypes.sendEmail)}
          onDelete={onDelete}
        />
      );
    }
    if (data.type === 'sendSMS') {
      const { input } = data;
      const { actionId } = input;
      const info = actionId ? actionId.toString() : undefined;
      return (
        <CommonFlowCard
          borderColor={'action'}
          editAction={{
            label: t('ActionNode.edit'),
            onClick: () => alert('Side panel content under construction 🛠️'),
          }}
          icon={<EmailIcon />}
          id={id}
          info={info}
          title={t(TRANSLATIONS.nodeTypes.sendSMS)}
          onDelete={onDelete}
        />
      );
    }
    if (data.type === 'tagsManageContact') {
      const { input } = data;
      const info = input.addTagIds.map((tag) => tag.value).join(', ');

      return (
        <CommonFlowCard
          borderColor={'action'}
          editAction={{
            label: t('ActionNode.edit'),
            onClick: () => alert('Side panel content under construction 🛠️'),
          }}
          icon={<GroupsIcon />}
          id={id}
          info={info}
          title={t(TRANSLATIONS.nodeTypes.tagsManageContact)}
          onDelete={onDelete}
        />
      );
    }
    if (data.type === 'httpRequest') {
      const { input } = data;
      const info = input.url ? input.url : undefined;
      return (
        <CommonFlowCard
          borderColor={'action'}
          editAction={{
            label: t('ActionNode.edit'),
            onClick: () => alert('Side panel content under construction 🛠️'),
          }}
          icon={<EmailIcon />}
          id={id}
          info={info}
          title={t(TRANSLATIONS.nodeTypes.httpRequest)}
          onDelete={onDelete}
        />
      );
    }

    return (
      <CommonFlowCard
        borderColor="default"
        id={data.id}
        info={t('ActionNode.removeNode')}
        title={t('ActionNode.default')}
        onDelete={onDelete}
      />
    );
  };

  return <RenderSubTypeComponent />;
};

export default memo(ActionNode);
